<template>
  <div class="dep">
    <!-- Selector de depuracion (dbo.CuracionCorridas) -->
    <div class="dep-toolbar">
      <div class="dep-toolbar__sel">
        <label class="dep-lbl">{{ $t('dep_depuracion') }}</label>
        <el-select
          v-model="idCorrida"
          :placeholder="$t('dep_seleccione_corrida')"
          :loading="cargandoCorridas"
          :disabled="cargando || ocupado"
          class="dep-select"
          @change="cargar"
        >
          <el-option v-for="c in corridas" :key="c.idCorrida" :label="etiquetaCorrida(c)" :value="c.idCorrida" />
        </el-select>
      </div>
      <div v-if="listo" class="dep-chips">
        <span class="dep-chip"><b>{{ nf(meta.n_items) }}</b> {{ $t('dep_items') }}</span>
        <span class="dep-chip">Accuracy <b>{{ pct(meta.accuracy) }}</b></span>
        <span class="dep-chip">F1 Macro <b>{{ pct(meta.f1_macro) }}</b></span>
        <span class="dep-chip" :title="meta.modelo">{{ $t('dep_taxonomia') }}: <b>{{ meta.taxonomia }}</b></span>
        <span class="dep-chip">{{ $t('dep_generado') }} {{ meta.generado }}</span>
      </div>
      <span class="dep-spacer"></span>
      <b-button size="sm" variant="outline-secondary" :disabled="!idCorrida || cargando || ocupado" @click="cargar">
        <i class="fas fa-sync-alt mr-1" :class="{ 'fa-spin': cargando }"></i>{{ $t('dep_recargar') }}
      </b-button>
    </div>

    <b-alert v-if="soloLectura" show variant="info" class="dep-alert">{{ $t('dep_solo_lectura') }}</b-alert>
    <b-alert :show="!!error" variant="danger" dismissible class="dep-alert" @dismissed="error = ''">{{ error }}</b-alert>

    <div v-if="cargando" class="dep-cargando">
      <b-spinner variant="primary" />
      <div>{{ $t('dep_cargando') }}</div>
    </div>

    <div v-else-if="!cargandoCorridas && !corridas.length && !error" class="dep-vacio">
      <i class="fas fa-brain fa-3x mb-3"></i>
      <p>{{ $t('dep_sin_corridas') }}</p>
    </div>

    <div v-else-if="listo" class="dep-layout">
      <!-- Colas: cada opcion filtra la vista de la derecha -->
      <aside class="dep-side">
        <template v-for="q in colas">
          <div v-if="q.g" :key="'g-' + q.g" class="dep-qgroup">{{ q.g }}</div>
          <button
            v-else
            :key="q.k"
            type="button"
            class="dep-q"
            :class="{ on: cola === q.k }"
            @click="elegirCola(q.k)"
          >
            <span class="dep-ic" :class="q.cls">{{ q.ic }}</span>
            <span class="dep-qt">
              {{ q.t }}<small>{{ q.s }}</small>
              <span v-if="conteoColas[q.k].prog != null" class="dep-prog"><b :style="{ width: conteoColas[q.k].prog + '%' }"></b></span>
            </span>
            <span class="dep-qn">{{ nf(conteoColas[q.k].n) }}</span>
          </button>
        </template>
      </aside>

      <section class="dep-main">
        <div class="dep-stats">
          <div v-for="s in stats" :key="s.l" class="dep-stat">
            <div class="dep-stat__l">{{ s.l }}</div>
            <div class="dep-stat__v">{{ s.v }}</div>
            <div class="dep-stat__s">{{ s.s }}</div>
            <div v-if="s.prog != null" class="dep-prog"><b :style="{ width: s.prog + '%' }"></b></div>
          </div>
        </div>

        <div class="dep-qhead">
          <div class="dep-qhead__txt">
            <h2>{{ titulo }}</h2>
            <p>{{ colaActual.d }} <span v-if="!colaActual.view && !soloLectura" class="dep-mut">{{ $t('dep_atajos') }}</span></p>
          </div>
          <b-button
            v-if="(cola === 'alta' || cola === 'media') && !soloLectura"
            size="sm"
            variant="outline-primary"
            :disabled="ocupado"
            :title="$t('dep_aceptar_97_t')"
            @click="aceptar97"
          >{{ $t('dep_aceptar_97') }}</b-button>
        </div>

        <!-- Vista: items -->
        <div v-if="!colaActual.view" class="dep-card">
          <div class="dep-filters">
            <input v-model="buscarInput" class="form-control form-control-sm dep-search" :placeholder="$t('dep_f_buscar')">
            <input v-model="fCatInput" class="form-control form-control-sm dep-cat-filter" :list="DL" :placeholder="$t('dep_f_cat')">
            <input v-model="fSugInput" class="form-control form-control-sm dep-cat-filter" :list="DL" :placeholder="$t('dep_f_sug')">
            <label class="dep-conf">{{ $t('dep_f_confianza') }}
              <input v-model="cMinInput" class="form-control form-control-sm dep-num-in" type="number" min="0" max="100" :placeholder="$t('dep_f_min')">
              –
              <input v-model="cMaxInput" class="form-control form-control-sm dep-num-in" type="number" min="0" max="100" :placeholder="$t('dep_f_max')">
            </label>
            <select v-model="estadoF" class="form-control form-control-sm dep-sel" @change="page = 0">
              <option value="pend">{{ $t('dep_e_pend') }}</option>
              <option value="done">{{ $t('dep_e_done') }}</option>
              <option value="prev">{{ $t('dep_e_prev') }}</option>
              <option value="all">{{ $t('dep_e_all') }}</option>
            </select>
            <select v-model="sort" class="form-control form-control-sm dep-sel">
              <option value="conf">{{ $t('dep_o_conf') }}</option>
              <option value="confasc">{{ $t('dep_o_confasc') }}</option>
              <option value="cat">{{ $t('dep_o_cat') }}</option>
              <option value="sug">{{ $t('dep_o_sug') }}</option>
              <option value="fila">{{ $t('dep_o_fila') }}</option>
            </select>
            <span v-if="catLock != null" class="dep-chip brand">
              {{ $t('dep_categoria_chip', { c: catNombre(catLock) }) }}
              <a href="#" class="ml-2" @click.prevent="catLock = null; page = 0">✕</a>
            </span>
            <span class="dep-spacer"></span>
            <b-button v-if="!soloLectura" size="sm" variant="outline-secondary" @click="seleccionarFiltrados">
              {{ $t('dep_sel_filtrados', { n: nf(indicesFiltrados.length) }) }}
            </b-button>
          </div>

          <div class="dep-tbl-wrap">
            <table class="dep-t">
              <thead>
                <tr>
                  <th style="width:30px">
                    <input type="checkbox" :checked="paginaSeleccionada" :disabled="soloLectura" @change="seleccionarPagina($event.target.checked)">
                  </th>
                  <th>{{ $t('dep_th_item') }}</th>
                  <th>{{ $t('dep_th_desc') }}</th>
                  <th>{{ $t('dep_th_cat') }}</th>
                  <th>{{ $t('dep_th_sug') }}</th>
                  <th>{{ $t('dep_th_estado') }}</th>
                  <th class="dep-col-acc">{{ $t('dep_th_acciones') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in filasPagina" :key="r.fila" :class="r.cls">
                  <td><input type="checkbox" :checked="r.sel" :disabled="soloLectura" @change="toggleSel(r.i, $event.target.checked)"></td>
                  <td class="dep-num dep-mut dep-small">Id {{ r.id }}<template v-if="r.sku"><br>SKU {{ r.sku }}</template></td>
                  <td class="dep-desc">
                    <div class="d1">{{ r.name || '—' }}</div>
                    <div v-if="r.det && r.det !== r.name" class="d2">{{ r.det }}</div>
                    <div class="d3">
                      <span v-if="r.brand">{{ $t('dep_marca') }}: {{ r.brand }}</span><span v-if="r.pn"> · P/N: {{ r.pn }}</span>
                    </div>
                    <div v-if="r.tags.length" class="dep-tags">
                      <span v-for="t in r.tags" :key="t.k" class="dep-tag" :class="t.cls">{{ t.txt }}</span>
                    </div>
                  </td>
                  <td class="dep-catcell">
                    <input
                      class="dep-cat-in"
                      :list="DL"
                      :value="r.cur"
                      :disabled="soloLectura || ocupado"
                      :title="$t('dep_t_editar')"
                      @change="onCategoria(r.i, $event)"
                      @keydown.enter="$event.target.blur()"
                    >
                    <div v-if="r.cur !== r.orig" class="dep-orig">{{ $t('dep_antes') }} <s>{{ r.orig }}</s></div>
                  </td>
                  <td>
                    <div class="dep-sug">
                      <button
                        v-for="s in r.sugs"
                        :key="s.k"
                        type="button"
                        class="dep-chipbtn"
                        :class="[s.k === 1 ? 'main' : 'alt', { same: s.same }]"
                        :disabled="soloLectura || ocupado"
                        :title="s.same ? $t('dep_t_actual') : $t('dep_t_asignar')"
                        @click="clickSugerencia(r.i, s.k)"
                      >{{ s.k === 1 ? '' : s.k + 'ª ' }}{{ s.c }}<span class="p">{{ s.ptxt }}</span></button>
                    </div>
                  </td>
                  <td><span class="dep-st" :class="r.est.cls">{{ r.est.txt }}</span></td>
                  <td class="dep-col-acc">
                    <div v-if="!soloLectura" class="dep-acts">
                      <button type="button" class="dep-ibtn ok" :disabled="ocupado" :title="$t('dep_t_validar')" @click="validar([r.i])">✔</button>
                      <button type="button" class="dep-ibtn" :disabled="ocupado" :title="$t('dep_t_na')" @click="noAplica([r.i], 'manual')">⊘</button>
                      <button v-if="r.decidido" type="button" class="dep-ibtn" :disabled="ocupado" :title="$t('dep_t_revertir')" @click="revertir([r.i])">↺</button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!filasPagina.length">
                  <td colspan="7" class="dep-empty">{{ estadoF === 'pend' ? $t('dep_vacio_pend') : $t('dep_vacio') }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="dep-pager">
            <span>{{ $t('dep_pager', { n: nf(indicesFiltrados.length), a: nf(rango.a), b: nf(rango.b) }) }}</span>
            <span class="dep-pager__nav">
              <b-button size="sm" variant="outline-secondary" :disabled="page === 0" @click="irPagina(page - 1)">← {{ $t('anterior') }}</b-button>
              {{ $t('pagina') }} {{ page + 1 }} {{ $t('de') }} {{ totalPaginas }}
              <b-button size="sm" variant="outline-secondary" :disabled="page >= totalPaginas - 1" @click="irPagina(page + 1)">{{ $t('siguiente') }} →</b-button>
              <select v-model.number="pageSize" class="form-control form-control-sm dep-sel dep-sel--xs" @change="page = 0">
                <option v-for="n in [50, 100, 200, 500]" :key="n" :value="n">{{ n }}</option>
              </select>
            </span>
          </div>
        </div>

        <!-- Vista: descripciones duplicadas -->
        <div v-else-if="colaActual.view === 'dup'">
          <div class="dep-card mb-3">
            <div class="dep-filters">
              <input v-model="buscarInput" class="form-control form-control-sm dep-search" :placeholder="$t('dep_dup_buscar')">
              <select v-model="estadoF" class="form-control form-control-sm dep-sel" @change="page = 0">
                <option value="pend">{{ $t('dep_dup_sin_resolver') }}</option>
                <option value="all">{{ $t('dep_dup_todos') }}</option>
              </select>
              <span class="dep-mut">{{ $t('dep_dup_resumen', { g: nf(gruposDup.total), n: nf(gruposDup.items) }) }}</span>
              <span class="dep-spacer"></span>
              <b-button v-if="gruposDup.slice.length && !soloLectura" size="sm" variant="primary" :disabled="ocupado" @click="unificarPagina">
                {{ $t('dep_dup_unificar_pagina') }}
              </b-button>
            </div>
          </div>
          <div v-for="g in gruposDup.slice" :key="g.key" class="dep-grp">
            <div class="dep-grp__h">
              <div class="dep-grp__tx">
                {{ g.nombre }}<span v-if="g.det" class="dep-mut"> · {{ g.det }}</span>
                <div class="dep-mut dep-small">{{ $t('dep_dup_items', { n: g.items.length }) }} · {{ g.reparto }}</div>
              </div>
              <span v-if="g.resuelto" class="dep-st val">✔ {{ $t('dep_dup_unificado') }}</span>
              <template v-if="!soloLectura">
                <b-button v-if="g.maj" size="sm" variant="outline-secondary" :disabled="ocupado" @click="unificarGrupo(g.idx, g.maj)">
                  {{ $t('dep_dup_a_mayoritaria') }} <b>{{ g.maj }}</b>
                </b-button>
                <b-button v-if="g.ms" size="sm" variant="outline-secondary" :disabled="ocupado" @click="unificarGrupo(g.idx, g.ms)">
                  {{ $t('dep_dup_a_sugerida') }} <b>{{ g.ms }}</b>
                </b-button>
                <input
                  class="form-control form-control-sm dep-cat-filter"
                  :list="DL"
                  :placeholder="$t('dep_dup_otra')"
                  :disabled="ocupado"
                  @change="unificarGrupoInput(g.idx, $event)"
                >
              </template>
            </div>
            <table class="dep-t dep-t--compact">
              <tbody>
                <tr v-for="it in g.items" :key="it.fila">
                  <td class="dep-num dep-mut" style="width:110px">Id {{ it.id }}</td>
                  <td class="dep-mut dep-small">{{ it.marca }}</td>
                  <td class="dep-catname">{{ it.cur }}<span v-if="it.cur !== it.orig" class="dep-mut"> ({{ $t('dep_antes') }} {{ it.orig }})</span></td>
                  <td class="dep-mut dep-small">{{ $t('dep_modelo') }} {{ it.sug }} {{ it.conf }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dep-pager dep-card">
            <span>{{ $t('pagina') }} {{ page + 1 }} {{ $t('de') }} {{ gruposDup.paginas }}</span>
            <span class="dep-pager__nav">
              <b-button size="sm" variant="outline-secondary" :disabled="page === 0" @click="irPagina(page - 1)">← {{ $t('anterior') }}</b-button>
              <b-button size="sm" variant="outline-secondary" :disabled="page >= gruposDup.paginas - 1" @click="irPagina(page + 1)">{{ $t('siguiente') }} →</b-button>
            </span>
          </div>
        </div>

        <!-- Vista: categorias -->
        <div v-else-if="colaActual.view === 'cats'" class="dep-card">
          <div class="dep-filters">
            <input v-model="catQInput" class="form-control form-control-sm dep-search" :placeholder="$t('dep_cat_buscar')">
            <span class="dep-mut">{{ $t('dep_cat_n', { n: nf(filasCats.length) }) }}</span>
          </div>
          <div class="dep-tbl-wrap dep-tbl-wrap--tall">
            <table class="dep-t">
              <thead>
                <tr>
                  <th class="sort" @click="ordenarCats('name')">{{ $t('dep_th_categoria') }}{{ flecha('name') }}</th>
                  <th class="sort r" @click="ordenarCats('n')">{{ $t('dep_th_items') }}{{ flecha('n') }}</th>
                  <th class="sort r" @click="ordenarCats('eff')">{{ $t('dep_th_con_cambios') }}{{ flecha('eff') }}</th>
                  <th class="sort r" @click="ordenarCats('f1')">{{ $t('dep_th_f1') }}{{ flecha('f1') }}</th>
                  <template v-if="!muestraDestino">
                    <th class="r">{{ $t('dep_th_precision') }}</th>
                    <th class="r">Recall</th>
                  </template>
                  <th class="sort r" @click="ordenarCats('err')">{{ $t('dep_th_discrepancias') }}{{ flecha('err') }}</th>
                  <th class="sort r" @click="ordenarCats('pend')">{{ $t('dep_th_pendientes') }}{{ flecha('pend') }}</th>
                  <th>{{ $t('dep_taxonomia') }}</th>
                  <th v-if="muestraDestino">{{ $t('dep_th_destino') }}</th>
                  <th>{{ $t('dep_th_acciones') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in filasCats" :key="c.ci">
                  <td class="dep-catname" style="min-width:260px">
                    {{ c.nombre }}
                    <div v-if="c.tags.length" class="dep-tags"><span v-for="t in c.tags" :key="t" class="dep-tag w">{{ t }}</span></div>
                    <div v-if="c.jer" class="dep-mut dep-small" style="font-weight:400">{{ c.jer }}</div>
                  </td>
                  <td class="r dep-num">{{ nf(c.n) }}</td>
                  <td class="r dep-num">{{ nf(c.eff) }}</td>
                  <td class="r dep-num">
                    <span v-if="c.f1 == null" class="dep-mut">—</span>
                    <span v-else class="dep-status" :class="c.f1cls">{{ pct(c.f1) }}</span>
                  </td>
                  <template v-if="!muestraDestino">
                    <td class="r dep-num">{{ pct(c.p) }}</td>
                    <td class="r dep-num">{{ pct(c.r) }}</td>
                  </template>
                  <td class="r dep-num">{{ nf(c.err) }}</td>
                  <td class="r dep-num">{{ nf(c.pend) }}</td>
                  <td><span v-if="c.tax">✓</span><span v-else class="dep-bad">✕</span></td>
                  <td v-if="muestraDestino" class="dep-small" style="min-width:240px">
                    <button v-if="c.destNombre" type="button" class="dep-chipbtn" :disabled="soloLectura" :title="$t('dep_dest_nombre')" @click="abrirFusion(c.nombre, c.destNombre)">≈ {{ c.destNombre }}</button>
                    <button v-if="c.destModelo" type="button" class="dep-chipbtn mt-1" :disabled="soloLectura" :title="$t('dep_dest_modelo')" @click="abrirFusion(c.nombre, c.destModelo)">🤖 {{ c.destModelo }}</button>
                  </td>
                  <td>
                    <div class="dep-acts">
                      <b-button size="sm" variant="outline-secondary" @click="verItemsCategoria(c.ci)">{{ $t('dep_ver_items') }}</b-button>
                      <b-button v-if="!soloLectura" size="sm" variant="outline-secondary" @click="abrirFusion(c.nombre, '')">{{ $t('dep_fusionar') }}</b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Vista: categorias con nombre similar -->
        <div v-else-if="colaActual.view === 'sim'" class="dep-card">
          <div v-if="!filasSim.length" class="dep-empty">✓ {{ $t('dep_sim_vacio') }}</div>
          <div v-else class="dep-tbl-wrap">
            <table class="dep-t">
              <thead>
                <tr>
                  <th>{{ $t('dep_th_cat_a') }}</th><th class="r">{{ $t('dep_th_items') }}</th>
                  <th>{{ $t('dep_th_cat_b') }}</th><th class="r">{{ $t('dep_th_items') }}</th>
                  <th class="r">{{ $t('dep_th_similitud') }}</th><th>{{ $t('dep_th_motivo') }}</th><th>{{ $t('dep_fusionar') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in filasSim" :key="p.a + '|' + p.b">
                  <td class="dep-catname">“{{ p.a }}” <span v-if="!p.ta" class="dep-tag w">{{ $t('dep_tag_tax') }}</span></td>
                  <td class="r dep-num">{{ nf(p.na) }}</td>
                  <td class="dep-catname">“{{ p.b }}” <span v-if="!p.tb" class="dep-tag w">{{ $t('dep_tag_tax') }}</span></td>
                  <td class="r dep-num">{{ nf(p.nb) }}</td>
                  <td class="r dep-num">{{ pct(p.sim, 0) }}</td>
                  <td class="dep-mut">{{ p.motivo }}</td>
                  <td>
                    <span v-if="p.resuelto" class="dep-st val">✔ {{ $t('dep_resuelto') }}</span>
                    <template v-else-if="!soloLectura">
                      <b-button v-if="!p.puedeKeep && !p.puedeRev" size="sm" variant="outline-secondary" @click="abrirFusion(p.drop, '')">{{ $t('dep_sim_elegir') }}</b-button>
                      <template v-else>
                        <b-button v-if="p.puedeKeep" size="sm" variant="primary" @click="abrirFusion(p.drop, p.keep)">{{ $t('dep_mover', { a: p.drop, b: p.keep }) }}</b-button>
                        <b-button v-if="p.puedeRev && p.puedeKeep" size="sm" variant="outline-secondary" @click="abrirFusion(p.keep, p.drop)">{{ $t('dep_al_reves') }}</b-button>
                      </template>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>

    <!-- Acciones masivas -->
    <div class="dep-bulk" :class="{ on: nSel > 0 && !soloLectura }">
      <span class="cnt">{{ $t('dep_seleccionados', { n: nf(nSel) }) }}</span>
      <button type="button" class="pri" :disabled="ocupado" :title="$t('dep_b_aceptar_t')" @click="bulkAceptar">✓ {{ $t('dep_b_aceptar') }}</button>
      <input v-model="bulkCat" :list="DL" :placeholder="$t('dep_b_asignar_ph')" @keydown.enter="bulkAsignar">
      <button type="button" :disabled="ocupado" @click="bulkAsignar">{{ $t('dep_b_asignar') }}</button>
      <button type="button" :disabled="ocupado" :title="$t('dep_t_validar')" @click="bulkValidar">✔ {{ $t('dep_b_validar') }}</button>
      <button type="button" :disabled="ocupado" @click="bulkNoAplica">{{ $t('dep_b_na') }}</button>
      <button type="button" :disabled="ocupado" @click="bulkRevertir">↺ {{ $t('dep_b_revertir') }}</button>
      <button type="button" @click="limpiarSeleccion">✕ {{ $t('dep_b_quitar') }}</button>
    </div>

    <!-- Fusionar / renombrar categoria -->
    <b-modal v-model="fusion.visible" :title="$t('dep_merge_titulo')" size="lg" @ok="confirmarFusion">
      <p class="mt-0">{{ $t('dep_merge_texto', { tax: meta ? meta.taxonomia : '' }) }}</p>
      <b-form-group :label="$t('dep_origen')">
        <input v-model="fusion.from" class="form-control" :list="DLALL">
      </b-form-group>
      <b-form-group :label="$t('dep_destino')">
        <input v-model="fusion.to" class="form-control" :list="DL">
      </b-form-group>
      <div class="dep-preview">
        <template v-if="!fusion.from.trim()">{{ $t('dep_merge_elige') }}</template>
        <template v-else>
          <b>{{ $t('dep_merge_prev', { n: nf(previewFusion.idx.length), a: fusion.from.trim(), b: fusion.to.trim() || '…' }) }}</b>
          <span v-if="previewFusion.destinoInvalido" class="dep-bad"> ⚠ {{ $t('dep_merge_invalido') }}</span>
          <div v-for="(n, k) in previewFusion.muestra" :key="k">· {{ n }}</div>
          <div v-if="previewFusion.idx.length > 8">…</div>
        </template>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">{{ $t('cancelar') }}</b-button>
        <b-button variant="primary" :disabled="ocupado" @click="ok()">{{ $t('dep_merge_btn') }}</b-button>
      </template>
    </b-modal>

    <datalist :id="DL">
      <option v-for="o in opcionesCats" :key="o.v" :value="o.v">{{ o.l }}</option>
    </datalist>
    <datalist :id="DLALL">
      <option v-for="c in catsEnUso" :key="c" :value="c"></option>
    </datalist>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';
import Swal from 'sweetalert2';
import depuracionModeloService from '@/api/depuracionModeloService';
import utilsService from '@/api/utilsService';

// Columnas de cada fila y bits de las colas: mismo contrato que el motor Python (dashboard-mm).
const F = { fila: 0, id: 1, sku: 2, brand: 3, pn: 4, name: 5, det: 6, cat: 7, p1: 8, c1: 9, p2: 10, c2: 11, p3: 12, c3: 13, flags: 14, dup: 15, fold: 16, prev: 17 };
const FL = { ALTA: 1, MEDIA: 2, BAJA: 4, DUP: 8, TAX: 16, PEQ: 32, JER: 64, SIN: 128, NUEVO: 256 };
const NA_LABEL = 'No aplica';
const COLAS_SIN_PENDIENTES = ['todos', 'cambios', 'jer'];
const COLAS_TODOS_LOS_ESTADOS = ['todos', 'cambios', 'porcat', 'jer'];
const PAGINA_DUP = 30;

function debounce(fn, ms) {
  let t;
  return function (v) { clearTimeout(t); t = setTimeout(() => fn.call(this, v), ms); };
}

// Normalizacion y similitud de nombres de categoria (destino sugerido "≈").
function normCat(s) {
  return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ').trim().split(' ')
    .map(w => (w.length > 4 && w.endsWith('ES') ? w.slice(0, -2) : w.length > 3 && w.endsWith('S') ? w.slice(0, -1) : w))
    .join(' ');
}
function similitud(a, b) {
  if (a === b) return 1;
  const bigramas = s => { const m = new Map(); for (let i = 0; i < s.length - 1; i++) { const k = s.substr(i, 2); m.set(k, (m.get(k) || 0) + 1); } return m; };
  const A = bigramas(a);
  const B = bigramas(b);
  let inter = 0;
  A.forEach((v, k) => { inter += Math.min(v, B.get(k) || 0); });
  return (2 * inter) / ((a.length - 1) + (b.length - 1) || 1);
}

export default {
  name: 'DepuracionModeloView',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      DL: 'dep-dl-cats',
      DLALL: 'dep-dl-todas',
      corridas: [],
      idCorrida: null,
      cargandoCorridas: false,
      cargando: false,
      error: '',
      listo: false,
      meta: null,
      soloLectura: utilsService.esSoloLectura(),
      ocupado: false,
      // Se incrementa cada vez que cambian los datos grandes (que viven fuera de la reactividad).
      version: 0,
      selVersion: 0,
      cola: 'alta',
      page: 0,
      pageSize: 100,
      buscarInput: '', search: '',
      fCatInput: '', fCat: '',
      fSugInput: '', fSug: '',
      cMinInput: '', cMin: '',
      cMaxInput: '', cMax: '',
      catQInput: '', catQ: '',
      estadoF: 'pend',
      sort: 'conf',
      catLock: null,
      catSort: { k: 'err', d: -1 },
      bulkCat: '',
      fusion: { visible: false, from: '', to: '' },
    };
  },

  created() {
    // 31 mil filas fuera del sistema reactivo de Vue: hacerlas reactivas congelaria la pantalla.
    this.st = null;
  },

  async mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    await this.cargarCorridas();
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
  },

  watch: {
    buscarInput: debounce(function (v) { this.search = v; this.page = 0; }, 250),
    fCatInput: debounce(function (v) { this.fCat = v; this.page = 0; }, 250),
    fSugInput: debounce(function (v) { this.fSug = v; this.page = 0; }, 250),
    cMinInput: debounce(function (v) { this.cMin = v; this.page = 0; }, 250),
    cMaxInput: debounce(function (v) { this.cMax = v; this.page = 0; }, 250),
    catQInput: debounce(function (v) { this.catQ = v; }, 200),
  },

  computed: {
    colas() {
      const m = this.meta;
      if (!m) return [];
      const tax = m.taxonomia;
      return [
        { g: this.$t('dep_g_prioridad') },
        { k: 'alta', ic: '!', cls: 'crit', f: FL.ALTA, t: this.$t('dep_q_alta'), s: this.$t('dep_q_alta_s', { p: this.pct(m.umbral_alta, 0) }), d: this.$t('dep_q_alta_d') },
        { k: 'dup', ic: '≡', cls: 'crit', f: FL.DUP, view: 'dup', t: this.$t('dep_q_dup'), s: this.$t('dep_q_dup_s'), d: this.$t('dep_q_dup_d') },
        { k: 'media', ic: '?', cls: 'warn', f: FL.MEDIA, t: this.$t('dep_q_media'), s: this.$t('dep_q_media_s', { a: this.pct(m.umbral_media, 0), b: this.pct(m.umbral_alta, 0) }), d: this.$t('dep_q_media_d') },
        { g: this.$t('dep_g_diccionario') },
        { k: 'sim', ic: '≈', cls: 'warn', view: 'sim', t: this.$t('dep_q_sim'), s: this.$t('dep_q_sim_s'), d: this.$t('dep_q_sim_d') },
        { k: 'tax', ic: '∉', cls: 'warn', f: FL.TAX, view: 'cats', t: this.$t('dep_q_tax'), s: this.$t('dep_q_tax_s', { tax }), d: this.$t('dep_q_tax_d', { tax }) },
        { k: 'peq', ic: '↓', cls: 'warn', f: FL.PEQ, view: 'cats', t: this.$t('dep_q_peq'), s: this.$t('dep_q_peq_s', { n: m.min_items }), d: this.$t('dep_q_peq_d', { n: m.min_items }) },
        { k: 'jer', ic: '⌥', cls: 'info', f: FL.JER, t: this.$t('dep_q_jer'), s: this.$t('dep_q_jer_s'), d: this.$t('dep_q_jer_d') },
        { g: this.$t('dep_g_explorar') },
        { k: 'baja', ic: '·', cls: 'mut', f: FL.BAJA, t: this.$t('dep_q_baja'), s: this.$t('dep_q_baja_s', { p: this.pct(m.umbral_media, 0) }), d: this.$t('dep_q_baja_d') },
        { k: 'nuevos', ic: '+', cls: 'info', f: FL.NUEVO, t: this.$t('dep_q_nuevos'), s: this.$t('dep_q_nuevos_s'), d: this.$t('dep_q_nuevos_d') },
        { k: 'porcat', ic: '▦', cls: 'info', view: 'cats', t: this.$t('dep_q_porcat'), s: this.$t('dep_q_porcat_s'), d: this.$t('dep_q_porcat_d') },
        { k: 'todos', ic: '∗', cls: 'mut', todos: true, t: this.$t('dep_q_todos'), s: this.$t('dep_q_todos_s'), d: this.$t('dep_q_todos_d') },
        { k: 'cambios', ic: '✎', cls: 'good', t: this.$t('dep_q_cambios'), s: this.$t('dep_q_cambios_s'), d: this.$t('dep_q_cambios_d') },
      ];
    },
    colaActual() {
      return this.colas.find(q => q.k === this.cola) || {};
    },
    titulo() {
      const t = this.colaActual.t || '';
      return this.catLock != null && this.cola === 'todos' ? `${t} · ${this.catNombre(this.catLock)}` : t;
    },
    conteoColas() {
      void this.version;
      const out = {};
      if (!this.st) return out;
      const st = this.st;
      for (const q of this.colas) {
        if (!q.k) continue;
        if (q.k === 'sim') { out[q.k] = { n: st.SIM.length, prog: null }; continue; }
        if (q.k === 'porcat') { out[q.k] = { n: st.CATINFO.filter(c => c.n > 0).length, prog: null }; continue; }
        if (q.k === 'cambios') { out[q.k] = { n: st.CH.size, prog: null }; continue; }
        const tot = this.colaIdx(q.k).length;
        const sinPend = COLAS_SIN_PENDIENTES.includes(q.k);
        const pend = sinPend ? tot : this.pendientes(q.k);
        out[q.k] = { n: pend, prog: !sinPend && tot ? (1 - pend / tot) * 100 : null };
      }
      return out;
    },
    stats() {
      void this.version;
      if (!this.st) return [];
      const st = this.st;
      const m = this.meta;
      const probs = ['alta', 'dup', 'media'].reduce((a, k) => a + this.colaIdx(k).length, 0);
      const pend = ['alta', 'dup', 'media'].reduce((a, k) => a + this.pendientes(k), 0);
      let mod = 0, val = 0, na = 0;
      st.CH.forEach(e => { if (e.a === 'CAMBIAR') mod++; else if (e.a === 'VALIDAR') val++; else na++; });
      const prev = m.n_validados_previos ? this.$t('dep_st_validados_prev', { n: this.nf(m.n_validados_previos) }) : '';
      return [
        { l: this.$t('dep_st_items'), v: this.nf(st.N), s: this.$t('dep_st_items_s', { enuso: this.nf(st.CATINFO.filter(c => c.n > 0).length), validas: this.nf(st.TAXSET.size), tax: m.taxonomia }) },
        { l: this.$t('dep_st_problemas'), v: this.nf(probs), s: this.$t('dep_st_problemas_s', { pend: this.nf(pend), pct: this.pct(probs ? 1 - pend / probs : 1, 0) }), prog: probs ? (1 - pend / probs) * 100 : 100 },
        { l: this.$t('dep_st_cambios'), v: this.nf(mod + na), s: this.$t('dep_st_cambios_s', { mod: this.nf(mod), na: this.nf(na) }) },
        { l: this.$t('dep_st_validados'), v: this.nf(val), s: prev + this.$t('dep_st_validados_s', { acc: this.pct(m.accuracy) }) },
      ];
    },
    indicesFiltrados() {
      void this.version;
      if (!this.st || this.colaActual.view) return [];
      let idx = this.colaIdx(this.cola);
      const lock = this.catLock;
      if (lock != null) idx = idx.filter(i => this.st.ROWS[i][F.cat] === lock || this.st.ROWS[i][F.p1] === lock);
      const s = this.search.trim().toLowerCase();
      const terms = s ? s.split(/\s+/) : [];
      const fc = this.fCat.trim().toLowerCase();
      const fs = this.fSug.trim().toLowerCase();
      const cmin = this.cMin === '' ? null : +this.cMin / 100;
      const cmax = this.cMax === '' ? null : +this.cMax / 100;
      const estadoF = this.estadoF;
      const ROWS = this.st.ROWS;
      idx = idx.filter(i => {
        const r = ROWS[i];
        if (estadoF !== 'all') {
          const e = this.estado(i);
          if (estadoF === 'pend' && e !== 'pend') return false;
          if (estadoF === 'done' && (e === 'pend' || e === 'prev')) return false;
          if (estadoF === 'prev' && e !== 'prev') return false;
        }
        if (fc && !this.effCat(i).toLowerCase().includes(fc) && !this.origCat(i).toLowerCase().includes(fc)) return false;
        if (fs && !this.sug(i).toLowerCase().includes(fs)) return false;
        if (cmin != null && this.conf(i) < cmin) return false;
        if (cmax != null && this.conf(i) > cmax) return false;
        if (terms.length) {
          const t = (r[F.brand] + ' ' + r[F.pn] + ' ' + r[F.name] + ' ' + r[F.det] + ' ' + r[F.id] + ' ' + r[F.sku] + ' ' + r[F.fila]).toLowerCase();
          for (const w of terms) if (!t.includes(w)) return false;
        }
        return true;
      });
      const k = this.sort;
      if (k === 'conf') idx.sort((a, b) => this.conf(b) - this.conf(a));
      else if (k === 'confasc') idx.sort((a, b) => this.conf(a) - this.conf(b));
      else if (k === 'cat') idx.sort((a, b) => this.origCat(a).localeCompare(this.origCat(b)) || this.conf(b) - this.conf(a));
      else if (k === 'sug') idx.sort((a, b) => this.sug(a).localeCompare(this.sug(b)) || this.conf(b) - this.conf(a));
      else idx.sort((a, b) => ROWS[a][F.fila] - ROWS[b][F.fila]);
      return idx;
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.indicesFiltrados.length / this.pageSize));
    },
    paginaIdx() {
      const pagina = Math.min(this.page, this.totalPaginas - 1);
      return this.indicesFiltrados.slice(pagina * this.pageSize, (pagina + 1) * this.pageSize);
    },
    rango() {
      const pagina = Math.min(this.page, this.totalPaginas - 1);
      const a = this.paginaIdx.length ? pagina * this.pageSize + 1 : 0;
      return { a, b: pagina * this.pageSize + this.paginaIdx.length };
    },
    filasPagina() {
      void this.version; void this.selVersion;
      const st = this.st;
      if (!st) return [];
      return this.paginaIdx.map(i => {
        const r = st.ROWS[i];
        const fila = r[F.fila];
        const e = this.estado(i);
        const cur = this.effCat(i);
        const sugs = [1, 2, 3].map(k => {
          const c = this.sug(i, k);
          const p = this.conf(i, k);
          return { k, c, ptxt: p < 0.01 ? '<1%' : this.pct(p, 0), same: c === cur || !this.validCat(c) };
        });
        return {
          i, fila, id: r[F.id], sku: r[F.sku], name: r[F.name], det: r[F.det], brand: r[F.brand], pn: r[F.pn],
          tags: this.tags(i), cur, orig: this.origCat(i), sugs, est: this.estadoBadge(e),
          decidido: st.CH.has(fila), sel: st.sel.has(i),
          cls: { sel: st.sel.has(i), chg: e === 'mod' || e === 'na', vld: e === 'val' },
        };
      });
    },
    paginaSeleccionada() {
      void this.selVersion;
      return this.paginaIdx.length > 0 && this.paginaIdx.every(i => this.st.sel.has(i));
    },
    nSel() {
      void this.selVersion;
      return this.st ? this.st.sel.size : 0;
    },
    gruposDup() {
      void this.version;
      const vacio = { total: 0, items: 0, paginas: 1, slice: [] };
      if (!this.st || this.colaActual.view !== 'dup') return vacio;
      const st = this.st;
      const grupos = new Map();
      for (const i of this.colaIdx('dup')) {
        const g = st.ROWS[i][F.dup];
        if (!grupos.has(g)) grupos.set(g, []);
        grupos.get(g).push(i);
      }
      let arr = Array.from(grupos.values());
      const s = this.search.trim().toLowerCase();
      if (s) arr = arr.filter(g => g.some(i => (st.ROWS[i][F.name] + ' ' + st.ROWS[i][F.det] + ' ' + st.ROWS[i][F.brand]).toLowerCase().includes(s)));
      const resuelto = g => new Set(g.map(i => this.effCat(i))).size === 1;
      if (this.estadoF === 'pend') arr = arr.filter(g => !resuelto(g));
      arr.sort((a, b) => b.length - a.length);
      const paginas = Math.max(1, Math.ceil(arr.length / PAGINA_DUP));
      const pagina = Math.min(this.page, paginas - 1);
      const slice = arr.slice(pagina * PAGINA_DUP, (pagina + 1) * PAGINA_DUP).map(g => {
        const cnt = {};
        g.forEach(i => { const c = this.effCat(i); cnt[c] = (cnt[c] || 0) + 1; });
        const orden = Object.entries(cnt).sort((a, b) => b[1] - a[1]);
        const majEntry = orden.find(([c]) => this.validCat(c));
        const maj = majEntry ? majEntry[0] : null;
        const votos = {};
        g.forEach(i => { votos[this.sug(i)] = (votos[this.sug(i)] || 0) + this.conf(i); });
        const ms = Object.entries(votos).sort((a, b) => b[1] - a[1])[0][0];
        const r0 = st.ROWS[g[0]];
        return {
          key: r0[F.dup], idx: g, nombre: r0[F.name], det: r0[F.det] && r0[F.det] !== r0[F.name] ? r0[F.det] : '',
          reparto: orden.map(([c, n]) => `${c} (${n})`).join(' · '),
          resuelto: resuelto(g), maj, ms: ms !== maj && this.validCat(ms) ? ms : null,
          items: g.map(i => {
            const r = st.ROWS[i];
            return { fila: r[F.fila], id: r[F.id], marca: r[F.brand] + (r[F.pn] ? ' · ' + r[F.pn] : ''), cur: this.effCat(i), orig: this.origCat(i), sug: this.sug(i), conf: this.pct(this.conf(i), 0) };
          }),
        };
      });
      return { total: arr.length, items: arr.reduce((a, g) => a + g.length, 0), paginas, slice };
    },
    muestraDestino() {
      return this.cola === 'tax' || this.cola === 'peq';
    },
    filasCats() {
      void this.version;
      if (!this.st || this.colaActual.view !== 'cats') return [];
      const st = this.st;
      const est = this.catStats();
      const filtro = this.cola === 'tax' ? (c => !st.CATINFO[c].tax && st.CATINFO[c].n > 0)
        : this.cola === 'peq' ? (c => st.CATINFO[c].n > 0 && !st.CATINFO[c].train)
          : (c => st.CATINFO[c].n > 0);
      let arr = st.CATS.map((c, i) => i).filter(filtro);
      const s = this.catQ.trim().toLowerCase();
      if (s) arr = arr.filter(i => st.CATS[i].toLowerCase().includes(s));
      const val = (i, k) => (k === 'name' ? st.CATS[i] : k === 'n' ? st.CATINFO[i].n : k === 'eff' ? (est.eff.get(st.CATS[i]) || 0)
        : k === 'f1' ? (st.CATINFO[i].f1 == null ? -1 : st.CATINFO[i].f1) : k === 'err' ? (est.err.get(i) || 0) : k === 'pend' ? (est.pend.get(i) || 0) : 0);
      const { k, d } = this.catSort;
      arr.sort((a, b) => { const A = val(a, k); const B = val(b, k); return (typeof A === 'string' ? A.localeCompare(B) : A - B) * d; });
      return arr.map(i => {
        const c = st.CATINFO[i];
        const tags = [];
        if (!c.tax && st.TAXSET.size) tags.push(this.$t('dep_tag_tax'));
        if (!c.train && c.n > 0) tags.push(this.$t('dep_no_entrena'));
        const dest = this.muestraDestino ? this.destinoSugerido(i) : {};
        return {
          ci: i, nombre: st.CATS[i], tags, jer: c.jer ? c.jer.filter(Boolean).join(' › ') : '',
          n: c.n, eff: est.eff.get(st.CATS[i]) || 0, f1: c.f1, p: c.p, r: c.r,
          f1cls: c.f1 == null ? '' : c.f1 >= 0.9 ? 'good' : c.f1 >= 0.7 ? 'warn' : 'crit',
          err: est.err.get(i) || 0, pend: est.pend.get(i) || 0, tax: c.tax,
          destNombre: dest.name || null, destModelo: dest.model || null,
        };
      });
    },
    filasSim() {
      void this.version;
      if (!this.st) return [];
      const st = this.st;
      const est = this.catStats();
      return st.SIM.map(p => {
        const ta = st.TAXSET.has(p.a);
        const tb = st.TAXSET.has(p.b);
        const na = est.eff.get(p.a) || 0;
        const nb = est.eff.get(p.b) || 0;
        // Destino recomendado: el que esta en la taxonomia; si ambos o ninguno, el de mas items.
        const keep = ta && !tb ? p.a : tb && !ta ? p.b : (p.na >= p.nb ? p.a : p.b);
        const drop = keep === p.a ? p.b : p.a;
        return {
          a: p.a, b: p.b, ta, tb, na, nb, sim: p.sim, keep, drop,
          motivo: p.motivo === 'identicas' ? this.$t('dep_motivo_identicas') : this.$t('dep_motivo_parecidas'),
          resuelto: na === 0 || nb === 0, puedeKeep: this.validCat(keep), puedeRev: this.validCat(drop),
        };
      });
    },
    previewFusion() {
      void this.version;
      const vacio = { idx: [], muestra: [], destinoInvalido: false };
      if (!this.st || !this.fusion.visible) return vacio;
      const f = this.fusion.from.trim();
      const t = this.fusion.to.trim();
      if (!f) return vacio;
      const idx = [];
      for (let i = 0; i < this.st.N; i++) if (this.effCat(i) === f) idx.push(i);
      return { idx, muestra: idx.slice(0, 8).map(i => this.st.ROWS[i][F.name]), destinoInvalido: !!t && !this.validCat(t) };
    },
    opcionesCats() {
      void this.version;
      if (!this.st) return [];
      const st = this.st;
      const lista = this.categoriasValidas().filter(c => c).map(c => {
        const j = st.CATINFO[st.CATIDX.get(c)].jer;
        return { v: c, l: j ? [j[0], j[1]].filter(Boolean).join(' › ') : '' };
      });
      lista.push({ v: NA_LABEL, l: this.$t('dep_marcar_na') });
      return lista;
    },
    catsEnUso() {
      void this.version;
      if (!this.st) return [];
      return this.st.CATS.filter((c, i) => this.st.CATINFO[i].n > 0);
    },
  },

  methods: {
    // ---------------------------------------------------------------- formato
    nf(v, d = 0) {
      return v == null || isNaN(v) ? '—' : Number(v).toLocaleString('es-CL', { minimumFractionDigits: d, maximumFractionDigits: d });
    },
    pct(v, d = 1) {
      return v == null || isNaN(v) ? '—' : this.nf(v * 100, d) + '%';
    },
    etiquetaCorrida(c) {
      const fecha = c.fechaHora ? new Date(c.fechaHora).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : c.idCorrida;
      const partes = [fecha];
      if (c.usuario) partes.push(c.usuario);
      if (c.accuracy != null) partes.push('accuracy ' + this.pct(c.accuracy));
      return partes.join(' · ');
    },
    toast(msg, icon = 'info', ms = 3500) {
      Swal.fire({ toast: true, position: 'top-end', icon, title: msg, showConfirmButton: false, timer: ms, timerProgressBar: true });
    },
    async confirmar(texto) {
      const r = await Swal.fire({ icon: 'question', text: texto, showCancelButton: true, confirmButtonText: this.$t('dep_si_continuar'), cancelButtonText: this.$t('cancelar') });
      return r.isConfirmed;
    },

    // ---------------------------------------------------------------- carga
    async cargarCorridas() {
      this.cargandoCorridas = true;
      this.error = '';
      try {
        this.corridas = await depuracionModeloService.getCorridas();
        if (this.corridas.length) {
          this.idCorrida = this.corridas[0].idCorrida;
          await this.cargar();
        }
      } catch (e) {
        this.error = this.$t('dep_error_corridas') + ' ' + e.message;
      } finally {
        this.cargandoCorridas = false;
      }
    },
    async cargar() {
      if (!this.idCorrida) return;
      this.cargando = true;
      this.error = '';
      try {
        const p = await depuracionModeloService.getPayload(this.idCorrida);
        const CATS = p.CATS;
        this.st = {
          CATS,
          CATINFO: p.CATINFO,
          SIM: p.SIM || [],
          ROWS: p.ROWS,
          N: p.ROWS.length,
          BYFILA: new Map(p.ROWS.map((r, i) => [r[F.fila], i])),
          CATIDX: new Map(CATS.map((c, i) => [c, i])),
          TAXSET: new Set(CATS.filter((c, i) => p.CATINFO[i].tax)),
          // fila -> { a: CAMBIAR | VALIDAR | NO_APLICA, nueva, ant, idc, origen, motivo, t }
          CH: new Map(),
          QIDX: {},
          sel: new Set(),
        };
        this.meta = p.META;
        this.construirIndices();
        const restaurados = this.restaurarRecientes(p.RECIENTES || []);
        this.listo = true;
        this.page = 0;
        this.version++;
        this.selVersion++;
        if (restaurados) this.toast(this.$t('dep_recientes', { n: this.nf(restaurados) }), 'info', 5000);
      } catch (e) {
        this.error = this.$t('dep_error_carga') + ' ' + e.message;
        this.listo = false;
      } finally {
        this.cargando = false;
      }
    },
    // Cambios propios de los ultimos 7 dias: muestran la categoria "antes" y se pueden revertir.
    restaurarRecientes(recientes) {
      const st = this.st;
      let n = 0;
      for (const r of recientes) {
        const i = st.BYFILA.get(r.fila);
        if (i == null) continue;
        const cur = this.origCat(i);
        if (r.a === 'VALIDAR') {
          if (cur === r.nueva) { st.CH.set(r.fila, { a: 'VALIDAR', nueva: cur, ant: cur, idc: r.idc, t: r.t, origen: r.origen, motivo: r.motivo }); n++; }
          continue;
        }
        if (cur !== r.nueva) continue; // alguien lo cambio despues
        st.ROWS[i][F.cat] = this.catIndex(r.ant || '');
        st.CH.set(r.fila, { a: r.a, nueva: r.nueva, ant: r.ant, idc: r.idc, t: r.t, origen: r.origen, motivo: r.motivo });
        this.recalcularFlags(i);
        n++;
      }
      return n;
    },

    // ---------------------------------------------------------------- acceso a filas
    catNombre(i) { return i < 0 ? '' : this.st.CATS[i]; },
    origCat(i) { return this.catNombre(this.st.ROWS[i][F.cat]); },
    effCat(i) {
      const e = this.st.CH.get(this.st.ROWS[i][F.fila]);
      if (e && e.a === 'CAMBIAR') return e.nueva;
      if (e && e.a === 'NO_APLICA') return NA_LABEL;
      return this.origCat(i);
    },
    estado(i) {
      const e = this.st.CH.get(this.st.ROWS[i][F.fila]);
      if (e) return e.a === 'VALIDAR' ? 'val' : e.a === 'NO_APLICA' ? 'na' : 'mod';
      return this.st.ROWS[i][F.prev] ? 'prev' : 'pend';
    },
    sug(i, k = 1) { return this.catNombre(this.st.ROWS[i][k === 1 ? F.p1 : k === 2 ? F.p2 : F.p3]); },
    conf(i, k = 1) { return this.st.ROWS[i][k === 1 ? F.c1 : k === 2 ? F.c2 : F.c3] / 1000; },
    tiene(i, f) { return (this.st.ROWS[i][F.flags] & f) !== 0; },
    validCat(c) { return c === NA_LABEL || !this.st.TAXSET.size || this.st.TAXSET.has(c); },
    categoriasValidas() {
      const st = this.st;
      return st.TAXSET.size ? st.CATS.filter(c => st.TAXSET.has(c)) : st.CATS;
    },
    catIndex(c) {
      const st = this.st;
      if (st.CATIDX.has(c)) return st.CATIDX.get(c);
      st.CATS.push(c);
      st.CATINFO.push({ n: 0, tax: st.TAXSET.has(c), train: false, f1: null, p: null, r: null, jer: null });
      st.CATIDX.set(c, st.CATS.length - 1);
      return st.CATS.length - 1;
    },
    recalcularFlags(i) {
      const r = this.st.ROWS[i];
      // Duplicado, categoria chica, jerarquia y item nuevo vienen del analisis y se conservan.
      let f = r[F.flags] & (FL.DUP | FL.PEQ | FL.JER | FL.NUEVO);
      const c = this.origCat(i);
      const s = this.sug(i);
      const p = this.conf(i);
      if (!c || c.toLowerCase() === NA_LABEL.toLowerCase()) f |= FL.SIN;
      else {
        if (s !== c && !(f & FL.NUEVO)) f |= p >= this.meta.umbral_alta ? FL.ALTA : p >= this.meta.umbral_media ? FL.MEDIA : FL.BAJA;
        if (this.st.TAXSET.size && !this.st.TAXSET.has(c)) f |= FL.TAX;
      }
      r[F.flags] = f;
    },
    construirIndices() {
      const st = this.st;
      const porFlag = {};
      for (const q of this.colas) if (q.k && (q.f || q.todos)) porFlag[q.k] = [];
      for (let i = 0; i < st.N; i++) {
        for (const q of this.colas) {
          if (!q.k || !porFlag[q.k]) continue;
          if (q.todos || this.tiene(i, q.f)) porFlag[q.k].push(i);
        }
      }
      st.QIDX = porFlag;
    },
    colaIdx(k) {
      const st = this.st;
      if (k === 'cambios') return Array.from(st.CH.keys()).map(f => st.BYFILA.get(f)).filter(i => i != null);
      return st.QIDX[k] || [];
    },
    pendientes(k) {
      let n = 0;
      for (const i of this.colaIdx(k)) if (this.estado(i) === 'pend') n++;
      return n;
    },
    tags(i) {
      const t = [];
      if (this.tiene(i, FL.ALTA)) t.push({ k: 'alta', cls: 'c', txt: this.$t('dep_tag_alta') });
      if (this.tiene(i, FL.MEDIA)) t.push({ k: 'media', cls: 'w', txt: this.$t('dep_tag_media') });
      if (this.tiene(i, FL.DUP)) t.push({ k: 'dup', cls: 'c', txt: this.$t('dep_tag_dup') });
      if (this.tiene(i, FL.TAX)) t.push({ k: 'tax', cls: 'w', txt: this.$t('dep_tag_tax') });
      if (this.tiene(i, FL.PEQ)) t.push({ k: 'peq', cls: 'w', txt: this.$t('dep_tag_peq') });
      if (this.tiene(i, FL.JER)) t.push({ k: 'jer', cls: '', txt: this.$t('dep_tag_jer') });
      if (this.tiene(i, FL.NUEVO)) t.push({ k: 'nuevo', cls: '', txt: this.$t('dep_tag_nuevo') });
      return t;
    },
    estadoBadge(e) {
      if (e === 'mod') return { cls: 'mod', txt: '✎ ' + this.$t('dep_st_mod') };
      if (e === 'val') return { cls: 'val', txt: '✔ ' + this.$t('dep_st_val') };
      if (e === 'na') return { cls: 'na', txt: this.$t('dep_st_na') };
      if (e === 'prev') return { cls: 'val', txt: '✔ ' + this.$t('dep_st_prev') };
      return { cls: 'pend', txt: this.$t('dep_st_pend') };
    },
    catStats() {
      // Conteos con los cambios aplicados y discrepancias/pendientes por categoria original.
      const st = this.st;
      const eff = new Map(), err = new Map(), pend = new Map();
      for (let i = 0; i < st.N; i++) {
        const c = this.effCat(i);
        eff.set(c, (eff.get(c) || 0) + 1);
        const o = st.ROWS[i][F.cat];
        if (this.tiene(i, FL.ALTA | FL.MEDIA)) {
          err.set(o, (err.get(o) || 0) + 1);
          if (this.estado(i) === 'pend') pend.set(o, (pend.get(o) || 0) + 1);
        }
      }
      return { eff, err, pend };
    },
    destinoSugerido(ci) {
      // ≈ nombre mas parecido en la taxonomia; 🤖 categoria que el modelo mas propone para sus items.
      const st = this.st;
      const votos = new Map();
      for (let i = 0; i < st.N; i++) {
        if (st.ROWS[i][F.cat] !== ci) continue;
        const s = st.ROWS[i][F.p1];
        if (s !== ci) votos.set(s, (votos.get(s) || 0) + st.ROWS[i][F.c1]);
      }
      const v = Array.from(votos.entries()).sort((a, b) => b[1] - a[1])[0];
      const nombre = st.CATS[ci];
      const nn = normCat(nombre);
      let mejor = null, ms = 0;
      st.TAXSET.forEach(c => {
        if (c === nombre) return;
        const s = similitud(nn, normCat(c));
        if (s > ms) { ms = s; mejor = c; }
      });
      return { model: v ? st.CATS[v[0]] : null, name: ms >= 0.75 ? mejor : null };
    },

    // ---------------------------------------------------------------- navegacion
    elegirCola(k) {
      this.cola = k;
      this.page = 0;
      this.catLock = null;
      this.limpiarSeleccion();
      this.buscarInput = ''; this.search = '';
      this.fCatInput = ''; this.fCat = '';
      this.fSugInput = ''; this.fSug = '';
      this.estadoF = COLAS_TODOS_LOS_ESTADOS.includes(k) ? 'all' : 'pend';
      window.scrollTo({ top: 0 });
    },
    irPagina(p) {
      this.page = p;
      window.scrollTo({ top: 0 });
    },
    verItemsCategoria(ci) {
      this.elegirCola('todos');
      this.catLock = ci;
    },
    ordenarCats(k) {
      this.catSort = { k, d: this.catSort.k === k ? -this.catSort.d : (k === 'name' ? 1 : -1) };
    },
    flecha(k) {
      return this.catSort.k === k ? (this.catSort.d > 0 ? ' ▲' : ' ▼') : '';
    },

    // ---------------------------------------------------------------- seleccion
    toggleSel(i, on) {
      if (on) this.st.sel.add(i); else this.st.sel.delete(i);
      this.selVersion++;
    },
    seleccionarPagina(on) {
      this.paginaIdx.forEach(i => (on ? this.st.sel.add(i) : this.st.sel.delete(i)));
      this.selVersion++;
    },
    seleccionarFiltrados() {
      this.indicesFiltrados.forEach(i => this.st.sel.add(i));
      this.selVersion++;
    },
    limpiarSeleccion() {
      if (this.st) this.st.sel.clear();
      this.selVersion++;
    },

    // ---------------------------------------------------------------- escritura
    setDbCat(i, cat) {
      const st = this.st;
      st.CH.delete(st.ROWS[i][F.fila]);
      st.ROWS[i][F.cat] = this.catIndex(cat);
      this.recalcularFlags(i);
    },
    resumen(label, r) {
      const p = [];
      if (r.ok) p.push(this.$t('dep_res_ok', { n: this.nf(r.ok) }));
      if (r.conf) p.push(this.$t('dep_res_conf', { n: this.nf(r.conf) }));
      if (r.bad) p.push(this.$t('dep_res_bad', { n: this.nf(r.bad), m: r.msgs.slice(0, 2).join(' · ') }));
      const icon = r.bad || r.conf ? 'warning' : 'success';
      this.toast(`${label}: ${p.join(' · ') || this.$t('dep_res_sin')}`, icon, r.conf || r.bad ? 8000 : 3500);
    },
    async enviar(sets) {
      const st = this.st;
      const r = { ok: 0, conf: 0, bad: 0, msgs: [] };
      if (!sets.length) return r;
      const cambios = sets.map(([i, e]) => ({
        id: st.ROWS[i][F.id], sku: st.ROWS[i][F.sku], accion: e.a, nueva: e.nueva, anterior: this.effCat(i),
        origen: e.origen, motivo: e.motivo, sugerencia: this.sug(i), confianza: this.conf(i),
      }));
      const resp = await depuracionModeloService.registrarCambios(this.meta.corrida, cambios);
      const ahora = new Date().toLocaleString('es-CL');
      (resp.resultados || []).forEach((res, k) => {
        const [i, e] = sets[k];
        const fila = st.ROWS[i][F.fila];
        if (res.resultado === 'APLICADO' || res.resultado === 'VALIDADO') {
          const previa = st.CH.get(fila);
          const val = res.resultado === 'VALIDADO';
          // Validar un item que ya cambiaste confirma ese cambio: se conserva como modificado.
          if (val && previa && previa.a !== 'VALIDAR') { r.ok++; return; }
          const ant = previa && previa.ant != null ? previa.ant : this.origCat(i);
          st.CH.set(fila, Object.assign({}, e, { a: val ? 'VALIDAR' : e.a, nueva: val ? this.effCat(i) : e.nueva, ant, idc: res.idCambio, t: ahora }));
          if (val && e.a !== 'VALIDAR' && res.detalle) r.msgs.push(res.detalle);
          r.ok++;
        } else if (res.resultado === 'CONFLICTO') {
          r.conf++;
          if (res.actual != null) this.setDbCat(i, res.actual);
        } else {
          r.bad++;
          if (res.detalle && !r.msgs.includes(res.detalle)) r.msgs.push(res.detalle);
        }
      });
      return r;
    },
    // list: [[i, decision | null]]; null = revertir
    async aplicar(label, list) {
      if (this.soloLectura || !list.length) return;
      if (this.ocupado) { this.toast(this.$t('dep_espera')); return; }
      const st = this.st;
      const revs = list.filter(([, e]) => e === null).map(([i]) => i);
      const sets = list.filter(([, e]) => e !== null)
        .map(([i, e]) => [i, e.a === 'CAMBIAR' && e.nueva === this.effCat(i) ? Object.assign({}, e, { a: 'VALIDAR' }) : e]);
      this.ocupado = true;
      const r = { ok: 0, conf: 0, bad: 0, msgs: [] };
      try {
        if (revs.length) {
          const ids = revs.map(i => st.CH.get(st.ROWS[i][F.fila])).filter(e => e && e.idc != null && e.a !== 'VALIDAR').map(e => e.idc);
          if (ids.length) {
            const resp = await depuracionModeloService.revertir(ids);
            (resp.resultados || []).forEach(x => {
              if (x.resultado === 'APLICADO') r.ok++;
              else if (x.resultado === 'CONFLICTO') r.conf++;
              else { r.bad++; if (x.detalle) r.msgs.push(x.detalle); }
            });
          } else {
            r.ok = revs.length;
          }
          revs.forEach(i => {
            const fila = st.ROWS[i][F.fila];
            const e = st.CH.get(fila);
            st.CH.delete(fila);
            if (e && e.a !== 'VALIDAR' && e.ant != null) { st.ROWS[i][F.cat] = this.catIndex(e.ant); this.recalcularFlags(i); }
          });
        }
        if (sets.length) {
          const r2 = await this.enviar(sets);
          r.ok += r2.ok; r.conf += r2.conf; r.bad += r2.bad; r.msgs.push.apply(r.msgs, r2.msgs);
        }
      } catch (err) {
        this.ocupado = false;
        this.version++;
        Swal.fire({ icon: 'error', title: 'Oops...', text: err.message });
        return;
      }
      this.ocupado = false;
      this.version++;
      this.resumen(label, r);
    },
    asignar(idxs, nueva, origen, motivo) {
      nueva = String(nueva || '').trim();
      if (!nueva) return false;
      if (nueva.toLowerCase() === NA_LABEL.toLowerCase()) { this.noAplica(idxs, origen, motivo); return true; }
      if (!this.validCat(nueva)) {
        this.toast(this.$t('dep_cat_invalida', { c: nueva, tax: this.meta.taxonomia }), 'warning', 5000);
        return false;
      }
      this.aplicar(this.$t('dep_op_asignado', { c: nueva }), idxs.map(i => [i, { a: 'CAMBIAR', nueva, origen, motivo }]));
      return true;
    },
    aceptarSugerencia(idxs, origen = 'sugerencia') {
      this.aplicar(this.$t('dep_op_aceptada'), idxs.map(i => (this.sug(i) === this.origCat(i)
        ? [i, { a: 'VALIDAR', nueva: this.origCat(i), origen, motivo: 'Coincide con el modelo' }]
        : [i, { a: 'CAMBIAR', nueva: this.sug(i), origen, motivo: `Sugerencia del modelo (${this.pct(this.conf(i), 0)})` }])));
    },
    validar(idxs) {
      this.aplicar(this.$t('dep_op_validados'), idxs.map(i => [i, {
        a: 'VALIDAR', nueva: this.effCat(i) === NA_LABEL ? this.origCat(i) : this.effCat(i), origen: 'manual', motivo: 'Revisado: categoría correcta',
      }]));
    },
    noAplica(idxs, origen, motivo) {
      this.aplicar(this.$t('dep_op_na'), idxs.map(i => [i, { a: 'NO_APLICA', nueva: NA_LABEL, origen, motivo: motivo || 'Marcado manualmente' }]));
    },
    revertir(idxs) {
      this.aplicar(this.$t('dep_op_revertidos'), idxs.filter(i => this.st.CH.has(this.st.ROWS[i][F.fila])).map(i => [i, null]));
    },
    clickSugerencia(i, k) {
      const c = this.sug(i, k);
      if (c === this.effCat(i) || !this.validCat(c)) return;
      this.aplicar(this.$t('dep_op_sugerencia', { c }), [[i, { a: 'CAMBIAR', nueva: c, origen: 'sugerencia', motivo: `Sugerencia ${k}ª del modelo (${this.pct(this.conf(i, k), 0)})` }]]);
    },
    onCategoria(i, ev) {
      const v = ev.target.value.trim();
      if (v && v !== this.effCat(i)) {
        if (this.asignar([i], v, 'manual', 'Edición manual') === false) ev.target.value = this.effCat(i);
      } else {
        ev.target.value = this.effCat(i);
      }
    },
    async aceptar97() {
      const idx = this.colaIdx(this.cola).filter(i => this.estado(i) === 'pend' && this.conf(i) >= 0.97);
      if (!idx.length) { this.toast(this.$t('dep_no_97')); return; }
      if (!(await this.confirmar(this.$t('dep_confirm_97', { n: this.nf(idx.length) })))) return;
      this.aceptarSugerencia(idx, 'masivo');
    },

    // ---------------------------------------------------------------- acciones masivas
    async bulkAceptar() {
      const a = Array.from(this.st.sel);
      if (a.length > 50 && !(await this.confirmar(this.$t('dep_c_aceptar', { n: this.nf(a.length) })))) return;
      this.aceptarSugerencia(a, 'masivo');
      this.limpiarSeleccion();
    },
    async bulkAsignar() {
      const v = this.bulkCat.trim();
      if (!v) return;
      const a = Array.from(this.st.sel);
      if (a.length > 50 && !(await this.confirmar(this.$t('dep_c_asignar', { c: v, n: this.nf(a.length) })))) return;
      if (this.asignar(a, v, 'masivo', 'Asignación masiva') === false) return;
      this.limpiarSeleccion();
      this.bulkCat = '';
    },
    bulkValidar() {
      this.validar(Array.from(this.st.sel));
      this.limpiarSeleccion();
    },
    async bulkNoAplica() {
      const a = Array.from(this.st.sel);
      if (!(await this.confirmar(this.$t('dep_c_na', { n: this.nf(a.length) })))) return;
      this.noAplica(a, 'masivo', 'Marcado masivo');
      this.limpiarSeleccion();
    },
    bulkRevertir() {
      this.revertir(Array.from(this.st.sel));
      this.limpiarSeleccion();
    },

    // ---------------------------------------------------------------- duplicados
    unificarGrupo(g, cat) {
      if (!this.validCat(cat)) { this.toast(this.$t('dep_cat_invalida', { c: cat, tax: this.meta.taxonomia }), 'warning', 5000); return; }
      const motivo = 'Unificación de descripción duplicada';
      this.aplicar(this.$t('dep_op_grupo', { c: cat }), g.map(i => (this.effCat(i) === cat
        ? [i, { a: 'VALIDAR', nueva: cat, origen: 'duplicado', motivo }]
        : [i, { a: cat === NA_LABEL ? 'NO_APLICA' : 'CAMBIAR', nueva: cat, origen: 'duplicado', motivo }])));
    },
    unificarGrupoInput(g, ev) {
      const v = ev.target.value.trim();
      if (v) this.unificarGrupo(g, v);
      ev.target.value = '';
    },
    unificarPagina() {
      const list = [];
      for (const g of this.gruposDup.slice) {
        if (!g.maj) continue;
        g.idx.forEach(i => list.push(this.effCat(i) !== g.maj
          ? [i, { a: 'CAMBIAR', nueva: g.maj, origen: 'duplicado', motivo: 'Unificación de descripción duplicada (mayoritaria)' }]
          : [i, { a: 'VALIDAR', nueva: g.maj, origen: 'duplicado', motivo: 'Unificación de descripción duplicada' }]));
      }
      this.aplicar(this.$t('dep_op_grupos'), list);
    },

    // ---------------------------------------------------------------- fusion de categorias
    abrirFusion(from, to) {
      if (this.soloLectura) return;
      this.fusion = { visible: true, from: from || '', to: to || '' };
    },
    confirmarFusion(ev) {
      const f = this.fusion.from.trim();
      const t = this.fusion.to.trim();
      if (!f || !t || f === t) { ev.preventDefault(); this.toast(this.$t('dep_merge_err_distintos'), 'warning'); return; }
      const idx = this.previewFusion.idx;
      if (!idx.length) { ev.preventDefault(); this.toast(this.$t('dep_merge_err_vacio'), 'warning'); return; }
      if (!this.validCat(t)) { ev.preventDefault(); this.toast(this.$t('dep_cat_invalida', { c: t, tax: this.meta.taxonomia }), 'warning', 5000); return; }
      this.aplicar(this.$t('dep_op_fusion', { a: f, b: t }), idx.map(i => [i, { a: 'CAMBIAR', nueva: t, origen: 'fusion', motivo: `Fusión de categoría “${f}”` }]));
    },
  },
};
</script>

<style scoped>
.dep {
  --ink: #111827; --ink-2: #374151; --muted: #6b7280; --muted-2: #9ca3af;
  --border: #e5e7eb; --border-2: #f3f4f6; --card: #ffffff; --card-2: #f9fafb;
  --brand: #00a3e0; --brand-ink: #0077a8; --brand-soft: rgba(0, 163, 224, .10);
  --good: #10b981; --good-ink: #047857; --good-soft: rgba(16, 185, 129, .12);
  --warn: #f59e0b; --warn-ink: #92400e; --warn-soft: rgba(245, 158, 11, .14);
  --crit: #ef4444; --crit-ink: #b91c1c; --crit-soft: rgba(239, 68, 68, .10);
  padding: 16px 20px 120px;
  color: var(--ink);
  font-size: 13px;
}
.dep-num { font-variant-numeric: tabular-nums; }
.dep-mut { color: var(--muted); }
.dep-small { font-size: 11.5px; }
.dep-bad { color: var(--crit-ink); font-weight: 600; }
.dep-spacer { flex: 1; }
.dep-alert { margin-bottom: 12px; }

/* Barra con el selector de depuracion */
.dep-toolbar { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 12px; margin-bottom: 14px; }
.dep-toolbar__sel { display: flex; flex-direction: column; gap: 4px; }
.dep-lbl { font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: var(--muted); margin: 0; }
.dep-select { width: 360px; }
.dep-chips { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; padding-bottom: 4px; }
.dep-chip { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 999px; background: var(--card); border: 1px solid var(--border); font-size: 12px; color: var(--ink-2); }
.dep-chip b { color: var(--ink); font-weight: 600; }
.dep-chip.brand { background: var(--brand-soft); border-color: transparent; color: var(--brand-ink); font-weight: 600; }
.dep-cargando, .dep-vacio { text-align: center; color: var(--muted); padding: 60px 20px; }
.dep-cargando div { margin-top: 10px; }

/* Layout: colas + contenido */
.dep-layout { display: grid; grid-template-columns: 265px minmax(0, 1fr); gap: 16px; }
@media (max-width: 1000px) { .dep-layout { grid-template-columns: 1fr; } }
.dep-side { position: sticky; top: 76px; align-self: start; max-height: calc(100vh - 90px); overflow: auto; }
.dep-qgroup { font-size: 10.5px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: var(--muted); margin: 14px 6px 6px; }
.dep-q { display: flex; align-items: center; gap: 10px; width: 100%; text-align: left; border: 1px solid transparent; background: none; border-radius: 10px; padding: 8px 10px; cursor: pointer; color: var(--ink); }
.dep-q:hover { background: var(--card); }
.dep-q.on { background: var(--card); border-color: var(--brand); box-shadow: 0 1px 3px rgba(16, 24, 40, .08); }
.dep-ic { width: 26px; height: 26px; border-radius: 8px; display: grid; place-items: center; font-size: 13px; flex: none; font-weight: 700; }
.dep-ic.crit { background: var(--crit-soft); color: var(--crit-ink); }
.dep-ic.warn { background: var(--warn-soft); color: var(--warn-ink); }
.dep-ic.info { background: var(--brand-soft); color: var(--brand-ink); }
.dep-ic.good { background: var(--good-soft); color: var(--good-ink); }
.dep-ic.mut { background: var(--border-2); color: var(--ink-2); }
.dep-qt { flex: 1; min-width: 0; font-size: 12.5px; font-weight: 600; line-height: 1.25; }
.dep-qt small { display: block; font-weight: 400; color: var(--muted); font-size: 11px; }
.dep-qn { font-size: 12px; font-weight: 700; font-variant-numeric: tabular-nums; color: var(--ink-2); }
.dep-prog { display: block; height: 5px; border-radius: 5px; background: var(--border); overflow: hidden; margin-top: 6px; }
.dep-prog b { display: block; height: 100%; background: var(--good); }

/* Indicadores */
.dep-stats { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; margin-bottom: 14px; }
@media (max-width: 1200px) { .dep-stats { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
.dep-stat { background: var(--card); border: 1px solid var(--border); border-radius: 12px; padding: 12px 14px; }
.dep-stat__l { font-size: 10.5px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: var(--muted); }
.dep-stat__v { font-size: 24px; font-weight: 700; margin-top: 2px; font-variant-numeric: tabular-nums; }
.dep-stat__s { font-size: 11.5px; color: var(--muted); }

.dep-qhead { display: flex; gap: 14px; align-items: flex-start; margin-bottom: 12px; }
.dep-qhead__txt { flex: 1; }
.dep-qhead h2 { margin: 0; font-size: 18px; font-weight: 700; color: var(--ink); }
.dep-qhead p { margin: 4px 0 0; color: var(--ink-2); font-size: 12.5px; max-width: 980px; line-height: 1.5; }

/* Tabla de items */
.dep-card { background: var(--card); border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
.dep-filters { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; padding: 12px 16px; border-bottom: 1px solid var(--border-2); }
.dep-search { max-width: 300px; }
.dep-cat-filter { width: 220px; }
.dep-num-in { width: 76px; display: inline-block; }
.dep-sel { width: auto; }
.dep-sel--xs { display: inline-block; width: 76px; margin-left: 6px; }
.dep-conf { display: inline-flex; gap: 6px; align-items: center; font-size: 12px; color: var(--ink-2); margin: 0; }
.dep-tbl-wrap { overflow: auto; }
.dep-tbl-wrap--tall { max-height: 72vh; }
.dep-t { width: 100%; border-collapse: collapse; font-size: 12.5px; }
.dep-t th { position: sticky; top: 0; z-index: 1; background: var(--card-2); text-align: left; font-size: 10.5px; letter-spacing: .06em; text-transform: uppercase; color: var(--ink-2); padding: 9px 12px; border-bottom: 1px solid var(--border); white-space: nowrap; user-select: none; }
.dep-t th.sort { cursor: pointer; }
.dep-t th.sort:hover { color: var(--brand-ink); }
.dep-t td { padding: 8px 12px; border-bottom: 1px solid var(--border-2); vertical-align: top; }
.dep-t .r { text-align: right; }
.dep-t--compact td { padding: 6px 12px; vertical-align: middle; }
.dep-t tr.sel td { background: var(--brand-soft) !important; }
.dep-t tr.chg td:first-child { box-shadow: inset 3px 0 0 var(--brand); }
.dep-t tr.vld td:first-child { box-shadow: inset 3px 0 0 var(--good); }
.dep-empty { text-align: center; color: var(--muted); padding: 30px !important; }
/* En pantallas angostas la tabla se desplaza, pero las acciones quedan siempre visibles. */
.dep-t .dep-col-acc { position: sticky; right: 0; z-index: 1; background: var(--card); box-shadow: -6px 0 8px -6px rgba(16, 24, 40, .18); }
.dep-t th.dep-col-acc { z-index: 2; background: var(--card-2); }
.dep-t tr.sel td.dep-col-acc { background: #e6f6fc !important; }
.dep-desc { min-width: 200px; max-width: 520px; }
.dep-desc .d1 { font-weight: 600; color: var(--ink); }
.dep-desc .d2 { color: var(--ink-2); font-size: 12px; }
.dep-desc .d3 { color: var(--muted); font-size: 11px; margin-top: 2px; }
.dep-catname { font-weight: 600; }
.dep-catcell { min-width: 170px; }
.dep-cat-in { width: 100%; border: 1px solid var(--border); background: var(--card-2); border-radius: 7px; padding: 5px 8px; font-size: 12px; font-weight: 600; color: var(--ink); }
.dep-cat-in:focus { outline: 2px solid var(--brand-soft); border-color: var(--brand); }
.dep-orig { font-size: 11px; color: var(--muted); margin-top: 3px; }
.dep-orig s { color: var(--crit-ink); }
.dep-sug { display: flex; flex-direction: column; gap: 4px; min-width: 180px; }
.dep-chipbtn { display: flex; align-items: center; gap: 6px; border: 1px solid var(--border); background: var(--card); border-radius: 8px; padding: 4px 8px; font-size: 12px; cursor: pointer; text-align: left; color: var(--ink); width: 100%; }
.dep-chipbtn:hover:not(:disabled) { border-color: var(--brand); background: var(--brand-soft); }
.dep-chipbtn .p { margin-left: auto; font-weight: 700; font-variant-numeric: tabular-nums; color: var(--ink-2); }
.dep-chipbtn.main { font-weight: 600; }
.dep-chipbtn.alt { font-size: 11px; padding: 2px 8px; color: var(--ink-2); }
.dep-chipbtn.same { border-style: dashed; cursor: default; opacity: .75; }
.dep-chipbtn:disabled { cursor: default; }
.dep-tags { display: flex; gap: 4px; flex-wrap: wrap; margin-top: 4px; }
.dep-tag { font-size: 10px; font-weight: 700; padding: 1px 6px; border-radius: 5px; background: var(--card-2); color: var(--ink-2); border: 1px solid var(--border-2); }
.dep-tag.c { background: var(--crit-soft); color: var(--crit-ink); border-color: transparent; }
.dep-tag.w { background: var(--warn-soft); color: var(--warn-ink); border-color: transparent; }
.dep-st { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 6px; white-space: nowrap; }
.dep-st.pend { background: var(--card-2); color: var(--ink-2); border: 1px solid var(--border); }
.dep-st.mod { background: var(--brand-soft); color: var(--brand-ink); }
.dep-st.val { background: var(--good-soft); color: var(--good-ink); }
.dep-st.na { background: var(--warn-soft); color: var(--warn-ink); }
.dep-status { display: inline-flex; font-size: 11px; font-weight: 700; padding: 1px 7px; border-radius: 6px; }
.dep-status.good { background: var(--good-soft); color: var(--good-ink); }
.dep-status.warn { background: var(--warn-soft); color: var(--warn-ink); }
.dep-status.crit { background: var(--crit-soft); color: var(--crit-ink); }
.dep-acts { display: flex; gap: 4px; }
.dep-ibtn { border: 1px solid var(--border); background: var(--card); border-radius: 7px; width: 30px; height: 28px; cursor: pointer; font-size: 13px; color: var(--ink-2); }
.dep-ibtn:hover:not(:disabled) { border-color: var(--brand); color: var(--brand-ink); }
.dep-ibtn.ok:hover:not(:disabled) { border-color: var(--good); color: var(--good-ink); }
.dep-pager { display: flex; gap: 8px; align-items: center; justify-content: space-between; padding: 10px 16px; border-top: 1px solid var(--border-2); font-size: 12.5px; color: var(--ink-2); flex-wrap: wrap; }
.dep-pager__nav { display: inline-flex; gap: 8px; align-items: center; }

/* Grupos de duplicados */
.dep-grp { border: 1px solid var(--border); border-radius: 12px; background: var(--card); margin-bottom: 10px; overflow: hidden; }
.dep-grp__h { display: flex; gap: 10px; align-items: center; padding: 10px 14px; background: var(--card-2); border-bottom: 1px solid var(--border-2); flex-wrap: wrap; }
.dep-grp__tx { flex: 1; min-width: 240px; font-weight: 600; font-size: 12.5px; }

.dep-preview { background: var(--card-2); border: 1px solid var(--border-2); border-radius: 10px; padding: 10px 12px; font-size: 12px; max-height: 220px; overflow: auto; }

/* Barra de acciones masivas */
.dep-bulk { position: fixed; left: 50%; bottom: 18px; transform: translateX(-50%) translateY(160%); transition: transform .2s; z-index: 1040; background: #0f172a; color: #e5e7eb; border-radius: 14px; box-shadow: 0 20px 50px -12px rgba(16, 24, 40, .45); padding: 10px 14px; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; max-width: min(1200px, 96vw); }
.dep-bulk.on { transform: translateX(-50%); }
.dep-bulk .cnt { font-weight: 700; margin-right: 6px; font-variant-numeric: tabular-nums; }
.dep-bulk button { border: 1px solid #334155; background: #1e293b; color: #e5e7eb; border-radius: 8px; padding: 7px 11px; font-size: 12.5px; font-weight: 600; cursor: pointer; }
.dep-bulk button:hover:not(:disabled) { border-color: var(--brand); }
.dep-bulk button.pri { background: var(--brand); border-color: var(--brand); color: #fff; }
.dep-bulk input { border: 1px solid #334155; background: #0b1220; color: #e5e7eb; border-radius: 8px; padding: 7px 10px; font-size: 12.5px; width: 250px; }
</style>
